module.exports = __webpack_public_path__ + "img/empty.623f22cc.png";